import { datadogRum } from "@datadog/browser-rum";
import { UserAction, UserFlow } from "@/types/Datadog";

const errorMsg: Record<UserFlow, string> = {
  "load-experiences": "Error while loading experiences",
  "master-data": "Error while fetching the master data",
  "load-raw": "Error while loading raw experience",
  "create-raw": "Error while creating raw experience",
  "create-operational": "Error while creating operational experience",
  "update-raw": "Error while saving raw experience",
  "delete-raw": "Error while deleting raw experience",
  "publish-raw": "Error while sending raw experience to review",
  "load-curation": "Error while loading curation content",
  "update-curation": "Error while saving curation content",
  "publish-curation": "Error while publishing curation content",
  "create-translation": "Error while creating translation",
  "update-translation": "Error while saving translation",
  "publish-translation": "Error while publishing translation",
  "load-translation": "Error while loading translation",
  "load-media": "Error while loading media",
  "upload-media": "Error while uploading media",
  "delete-media": "Error while deleting media",
  "update-media": "Error while saving media",
  "publish-media": "Error while publishing media",
  "load-option": "Error while loading option",
  "create-option": "Error while creating option",
  "update-option": "Error while saving option",
  "update-agenda-slot-capacity": "Error while updating agenda slot capacity",
  "toggle-agenda-slot": "Error while toggling agenda slot",
  "load-activity-log": "Error while loading activity log change logs",
  "load-i18n": "Error while loading i18n bundle",
  "create-premade-item": "Error while creating premade item",
  "create-premade-category": "Error while creating premade category",
  "update-masterdata-translation": "Error while updating masterdata translation",
  "get-distribution-content": "Error while fetching distribution content",
  "advanced-search-result-translation-missing": "Translation missing for the results of the advanced search",
  "load-revision": "Error while loading revision",
  "load-raw-asterix-service-and-modalities": "Error while loading Asterix Service and Modalities in Raw",
  "roles-no-such-role": "No such role",
  "load-allotments": "Error while loading allotments",
  "load-feature-flag": "Error while loading feature flag",
  "complete-raw": "Error while completing raw experience",
  "load-supplier-profile": "Error while loading supplier profile",
  "unlock-supplier-profile": "Error while unlocking supplier profile",
  "update-supplier-profile": "Error while updating supplier profile",
  "decode-token": "Error decoding token",
  "set-supplier-type-internal": "Error while changing supplier type to internal",
  "invite-supplier-account": "Error while inviting supplier account",
  "load-audit-timeline": "Error while loading audit timeline",
};

export function useLogger() {
  const config = useRuntimeConfig();

  function logError(flow: UserFlow, originalError?: unknown) {
    const error = new Error(errorMsg[flow] ?? "Unknown error");
    if (originalError) {
      // Set the causes property which Datadog will recognize as the original error
      error.cause = originalError;
    }
    datadogRum.addError(error);

    // log the error in the browser console if Datadog is disabled (local env)
    if (config.public.DISABLE_DATADOG) {
      console.error(error);
    }
  }

  function logAction(name: UserAction, context: object) {
    datadogRum.addAction(name, context);
  }

  return {
    logError,
    logAction,
  };
}
